export default [
{
  "readingcompTitle": "Working as an Account Manager at Essity",
  "topic": "Workplace",
  "level": "b1",
  "image": "/Images/tork-head.webp",
  "vocabulary": [
    "provides - biztosít",
    "hygiene - higiénia",
    "solutions - megoldások",
    "client - ügyfél",
    "improve - javít",
  ],
  "paragraphs": [
    {
      "text": [
        "<p><strong>Working as an Account Manager at Essity</strong></p>",
        "<p>I work as an account manager at Essity, a company that provides hygiene and health products. My job is to talk to clients, understand what they need, and help them choose the best products. These can include things like paper towels, soap dispensers, or medical supplies.</p>",
        "<p>Each day starts with checking emails and planning my meetings. I often visit customers to answer their questions and help solve any problems. Good communication is very important in this role. I also work with other teams at Essity, like marketing and logistics, to make sure everything runs smoothly.</p>",
        "<p>What I like most about my job is that every day is different. I get to meet many people and help them improve their workplaces. It feels good to know that our products make a real difference.</p>"
      ],
      "questions": [
        {
          "number": "1",
          "question": "What is the main job of an account manager at Essity?",
          "choices": [
            "A. To make health products",
            "B. To clean offices",
            "C. To help clients find the right products",
            "D. To deliver orders"
          ]
        },
        {
          "number": "2",
          "question": "What does the account manager do in the morning?",
          "choices": [
            "A. Visit clients",
            "B. Check emails and plan meetings",
            "C. Go to the warehouse",
            "D. Make new products"
          ]
        },
        {
          "number": "3",
          "question": "Why is communication important in this job?",
          "choices": [
            "A. To sell more products",
            "B. To travel more",
            "C. To solve problems and help clients",
            "D. To avoid work"
          ]
        },
        {
          "number": "4",
          "question": "Which teams does the account manager work with?",
          "choices": [
            "A. Only logistics",
            "B. Only marketing",
            "C. Marketing and logistics",
            "D. Sales and cleaning"
          ]
        },
        {
          "number": "5",
          "question": "What does the account manager enjoy most?",
          "choices": [
            "A. The office view",
            "B. Making products",
            "C. Meeting people and making a difference",
            "D. Working alone"
          ]
          }
        ]
      }
    ]
  }
]
